module.exports = __webpack_public_path__ + "static/media/iot-application-03.73660e92.jpg";